module.exports = __webpack_public_path__ + "img/schema_siegemoule_8b.44109536.svg";